<app-nav-steps *ngIf="!isDetailsView"></app-nav-steps>
<div class="personal-data-container component-container">
  <div *ngIf="!isDetailsView" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div *ngIf="currentInstallationFlow === installationFlowType.NewInstallation" class="page-heading text-center text-uppercase">
      {{ 'personal-data.heading' | translate }}
    </div>
    <div *ngIf="currentInstallationFlow === installationFlowType.UpdateInstallation" class="page-heading text-center text-uppercase">
      {{ 'personal-data.update-installation.heading' | translate }}
    </div>
    <div *ngIf="showTechnicianDataTitle" class="page-heading text-center text-uppercase">
      {{ 'installation-data.' + getFlowTitle() | translate }}
    </div>
  </div>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align text-uppercase page-title">
      {{ 'personal-data.title' | translate }}
      <span *ngIf="currentInstallationFlow === installationFlowType.MainsConnection">
        - {{ 'lookup.' + buildingTypeKey + '.options.' + currentFormType.lookUpKey + '.name' | translate }}
      </span>
      <span
        *ngIf="
          currentInstallationFlow === installationFlowType.ChangeHouseConnection ||
          currentInstallationFlow === installationFlowType.ConversionToGas
        ">
        - {{ 'lookup.' + changeSubtypeKey + '.options.' + currentFormType.lookUpKey + '.name' | translate }}
      </span>
      <span *ngIf="currentInstallationFlow === installationFlowType.FeedInSystem">
        - {{ 'lookup.' + feedInTypeKey + '.options.' + feedInInstallationType + '.name' | translate }}
      </span>
    </div>
  </div>

  <app-review-section
    #connectionAddressSection
    [title]="'personal-data.form-details.connection-address-title' | translate"
    [tooltip]="'tooltips.personal-data.connection-address' | translate"
    [sectionId]="ConnectionAddressSectionIdentifier"
    [applicationId]="applicationId"
    [isDetailsView]="isDetailsView"
    [showButtonsPredicate]="hideButtonsForChimneySweeper">
    <app-connection-address
      *ngIf="connectionData"
      [connectionData]="connectionData"
      [isReadOnly]="!connectionAddressSection.isDataEditable"
      [areLocationFieldsHidden]="areLocationFieldsHidden()"
      [applicationId]="applicationId"></app-connection-address>
    <app-location-fields
      [hidden]="areLocationFieldsHidden()"
      [isDisabled]="!connectionAddressSection.isDataEditable"
      [areaLocations]="areaLocations"
      [isDetailsView]="isReadOnly"
      (onRemoveAreaLocation)="removeAreaLocation($event)"></app-location-fields>
  </app-review-section>

  <app-review-section
    #subscriberSection
    [applicationId]="applicationId"
    [sectionId]="ConnectionAddressSectionSubscriber"
    [title]="'personal-data.form-details.subscriber-title' | translate"
    [tooltip]="'tooltips.personal-data.subscriber' | translate"
    [isDetailsView]="isDetailsView"
    [showButtonsPredicate]="hideButtonsForChimneySweeper">
    <app-subscriber
      *ngIf="subscriberData"
      [connectionData]="connectionData"
      [isReadOnly]="!subscriberSection.isDataEditable"
      [subscriberData]="subscriberData"
      [documents]="documents"
      [isDetailsView]="isDetailsView"></app-subscriber>
  </app-review-section>

  <app-technician-info
    *ngIf="isReadOnly || isDetailsView"
    [isReadOnly]="true"
    [technicianData]="technicianData"
    [applicationId]="applicationId"
    [isDetailsView]="isDetailsView"></app-technician-info>

  <app-invoice-address *ngIf="showInvoiceAddress" [isReadOnly]="isReadOnly" [invoiceAddress]="invoiceAddress"></app-invoice-address>

  <app-responsible-installer
    *ngIf="showInstallerComponent"
    [installerData]="installerData"
    [isReadOnly]="isReadOnly"></app-responsible-installer>
  <app-installer-company
    *ngIf="showInstallerCompanyComponent"
    [applicationId]="applicationId"
    [isReadOnly]="isReadOnly"
    [isDetailsView]="isDetailsView"
    [systemCompanyInstallerData]="installerCompanyData"></app-installer-company>

  <div *ngIf="!isReadOnly && !isDetailsView" class="ui-g-12 submit-button-section text-center">
    <button
      (click)="saveFormData()"
      [disabled]="disableFormButtons || isLoading"
      class="submit-button"
      label="{{ 'basic-profile.jurisdiction.proceed' | translate | uppercase }}"
      pButton></button>
  </div>
</div>
<app-loader *ngIf="isLoading"></app-loader>
